import { useDispatch, useSelector } from 'react-redux';
import { EServiceId } from '../../../../../../../../types/reducers/publishTerms';
import { useCallback, useMemo } from 'react';
import { selectPublishTermsService as setPublishTermsService } from '../../../../../../../../actions/publishTerms';
import { selectServices } from '../../../../../../../../reducers/v2/promotion/selectors/selectServices';
import { selectIsServicesPromotionToggleChecked } from '../../../../../../../../reducers/v2/promotion/selectors';
import { selectCompetitorsExperiment } from '../../../../../../../../selectors/experiments';
import { useServicesAnalytics } from '../../hooks';

interface IService {
  type: EServiceId;
  selected: boolean;
  blurred: boolean;
  disabled: boolean;
  price: number;
}

interface IUseServices {
  services: IService[];
  selectedService: IService | undefined;
  selectService: (type: EServiceId) => void;
}

export const useServices = (): IUseServices => {
  const dispatch = useDispatch();

  const { trackServiceChange } = useServicesAnalytics();

  const promotionServices = useSelector(selectServices);
  const isPromotionToggleChecked = useSelector(selectIsServicesPromotionToggleChecked);
  const showReversed = useSelector(selectCompetitorsExperiment);

  const services = useMemo(() => {
    const _promotionServices = promotionServices.map(service => {
      return {
        type: service.type,
        selected: service.selected,
        blurred: !isPromotionToggleChecked,
        price: service.price,
        // На данный момент нет условий для дизейблинга
        // но остается контракт на случай необходимости
        disabled: false,
      };
    });

    return showReversed ? _promotionServices.reverse() : _promotionServices;
  }, [isPromotionToggleChecked, promotionServices, showReversed]);

  const selectedService = services.find(service => service.selected);

  const handleSelectService = useCallback(
    (serviceId: EServiceId) => {
      dispatch(setPublishTermsService(serviceId));

      trackServiceChange();
    },
    [dispatch, trackServiceChange],
  );

  return { services, selectService: handleSelectService, selectedService };
};
